export default function ValidateCity(City) {
  var valid = true;

  var rfvCity = City.siblings("#CityRequired");

  rfvCity.hide();
  City.removeClass("error");
  if ($.trim(City.val()).length == 0) {
    valid = false;
    rfvCity.show();
    City.addClass("error");
  }
  return valid;
}